import logger from '@/app/logger';

const STORAGE_KEY = 'mt.hotbarPinnedCharacterId';

function loadPin(): string | null {
    try {
        return typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    } catch (err) {
        logger.warn('Could not read the hotbar pin', err);
        return null;
    }
}

function persistPin(id: string | null): void {
    try {
        if (typeof localStorage === 'undefined') return;
        if (id) localStorage.setItem(STORAGE_KEY, id);
        else localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
        logger.warn('Could not persist the hotbar pin', err);
    }
}

interface HotbarPinState {
    pinnedCharacterId: string | null;
}

const state: HotbarPinState = {
    pinnedCharacterId: loadPin(),
};

const mutations = {
    setPinned(state: HotbarPinState, id: string | null): void {
        state.pinnedCharacterId = id;
        persistPin(id);
    },
};

const getters = {
    isPinned:
        (state: HotbarPinState) =>
        (id: string): boolean =>
            !!id && state.pinnedCharacterId === id,
};

const actions = {
    toggle(
        { state, commit }: { state: HotbarPinState; commit: (m: string, p: string | null) => void },
        id: string,
    ): void {
        commit('setPinned', state.pinnedCharacterId === id ? null : id);
    },
};

const HotbarPinStore = {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};

export default HotbarPinStore;
